// extracted by mini-css-extract-plugin
export default {"Layout":"HomePage_Layout__QwhNz","Layout__Header":"HomePage_Layout__Header__0i-QT","Layout__Body":"HomePage_Layout__Body__wAHgG","Layout__Footer":"HomePage_Layout__Footer__X8-bH"};